import humanizeString from 'humanize-string';
import { CustomKeyAttributes } from '@loyalty/shared-common/profile-api-client';
import { Fields } from '@react-awesome-query-builder/core';
import { RequiredProps } from '@loyalty/shared-common';
import { BaseConfigSettings } from '../fields';
import { excludedOperators } from '../settings';
import { profileFields } from './profile-fields';

export function binaryBasicFields(
  settings: BaseConfigSettings,
  options: { customKeys?: CustomKeyAttributes[]; counters: string[]; tags: string[] },
): Fields {
  const { t } = settings;
  const { tags, counters } = options;
  const fields = {
    origin: {
      label: t('rule.criteria.origin'),
      type: 'text',
      excludeOperators: excludedOperators,
      valueSources: ['value'],
    },
    label: {
      label: t('rule.criteria.label'),
      type: 'text',
      excludeOperators: excludedOperators,
      valueSources: ['value'],
    },
    value: {
      label: t('rule.criteria.value'),
      type: 'text',
      excludeOperators: excludedOperators,
      valueSources: ['value'],
    },
    timestamp: {
      label: settings.t('rule.criteria.date'),
      type: 'datetime',
      preferWidgets: ['date'],
    },
  } as any;

  if (settings?.eventName?.startsWith('webhook_')) {
    // custom binary via webhook
    if (counters?.length) {
      fields['formattedCounters'] = {
        label: t('rule.criteria.binary.counters'),
        type: '!struct',
        subfields: counters.reduce((result: Record<string, any>, item: string) => {
          result[item] = {
            label: humanizeString(item),
            type: 'number',
            excludeOperators: excludedOperators,
            valueSources: ['value'],
          };
          return result;
        }, {}),
      };
    }

    if (tags?.length) {
      fields['formattedTags'] = {
        label: t('rule.criteria.binary.tags'),
        type: '!struct',
        subfields: tags.reduce((result: Record<string, any>, item: string) => {
          result[item] = {
            label: humanizeString(item),
            type: 'text',
            excludeOperators: excludedOperators,
            valueSources: ['value'],
          };
          return result;
        }, {}),
      };
    }
  } else {
    // generic binary
    fields['tags'] = {
      label: t('rule.criteria.binary.tags'),
      type: '!group',
      subfields: {
        name: {
          label: t('rule.criteria.name'),
          type: 'text',
          excludeOperators: excludedOperators,
          valueSources: ['value'],
        },
        value: {
          label: t('rule.criteria.value'),
          type: 'text',
          excludeOperators: excludedOperators,
          valueSources: ['value'],
        },
      },
    };

    fields['counters'] = {
      label: t('rule.criteria.binary.counters'),
      type: '!group',
      subfields: {
        name: {
          label: t('rule.criteria.name'),
          type: 'text',
          excludeOperators: excludedOperators,
          valueSources: ['value'],
        },
        value: {
          label: t('rule.criteria.value'),
          type: 'number',
          excludeOperators: excludedOperators,
          valueSources: ['value'],
        },
      },
    };
  }

  return {
    event: {
      label: t('rule.criteria.event'),
      type: '!group',
      subfields: fields,
    },
    profile: {
      label: t('rule.criteria.profile'),
      type: '!group',
      subfields: profileFields(settings, options?.customKeys),
    },
  };
}
